/* global google */

async function initLocationBar() {
	// eslint-disable-next-line no-unused-vars
	const { Map, InfoWindow } = await google.maps.importLibrary('maps');
	const parser = new DOMParser();

	// eslint-disable-next-line no-unused-vars
	const { AdvancedMarkerElement, PinElement } =
		await google.maps.importLibrary('marker');

	const mapElements = document.querySelectorAll(
		'.block-location-bar__map[data-lat][data-lng]'
	);

	const addMarker = (mapElement, map) => {
		const latlng = new google.maps.LatLng(
			mapElement.getAttribute('data-lat'),
			mapElement.getAttribute('data-lng')
		);

		const markerHtml = mapElement
			.getAttribute('data-title')
			.replace(
				'<h3 class="block-location-bar__map-marker-title',
				'<h3 id="location-bar-marker-title" class="block-location-bar__map-marker-title'
			);

		const markerSettings = {
			position: latlng,
			map,
			title: `<div class="block-location-bar__map-marker" aria-labelledby="location-bar-marker-title">${markerHtml}</div>`,
			content: parser.parseFromString(
				'<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 18C10 10.26 16.26 4 24 4C31.74 4 38 10.26 38 18C38 28.5 24 44 24 44C24 44 10 28.5 10 18ZM19 18C19 20.76 21.24 23 24 23C26.76 23 29 20.76 29 18C29 15.24 26.76 13 24 13C21.24 13 19 15.24 19 18Z" fill="#253746"/><circle cx="24" cy="18" r="5" fill="white"/></svg>',
				'image/svg+xml'
			).documentElement,
		};

		const marker = new AdvancedMarkerElement(markerSettings);

		map.markers.push(marker);

		marker.addListener('click', () => {
			map.infoWindow.close();
			map.infoWindow.setContent(marker.title);
			map.infoWindow.open({
				anchor: marker,
				map: marker.map,
				shouldFocus: false,
			});
		});

		centerMap(map);

		return marker;
	};

	const centerMap = (map) => {
		const bounds = new google.maps.LatLngBounds();

		for (let i = 0; i < map.markers.length; i++) {
			bounds.extend(map.markers[i].position);
		}

		if (1 === map.markers.length) {
			map.setCenter(bounds.getCenter());
			map.setZoom(16);
		} else {
			map.fitBounds(bounds);
		}
	};

	if (mapElements.length > 0) {
		mapElements.forEach((mapElement) => {
			const options = {
				center: {
					lat: 0,
					lng: 0,
				},
				zoom: 4,
				mapTypeControl: false,
				fullscreenControl: false,
				streetViewControl: false,
				scaleControl: false,
				zoomControl: true,
				mapId: '898eed5453741db8',
			};

			const map = new Map(mapElement, options);
			map.markers = [];
			map.infoWindow = new InfoWindow();

			addMarker(mapElement, map);
		});
	}
}

window.addEventListener('google-maps-loaded', initLocationBar);
